<template>
  <form class="w-100">
    <p class="card-text">
      <b-form-group label="Feasibility:"
                    label-for="feasibility">
        <b-form-select id="feasibility"
                       v-model="evaluation.feasibility"
                       :disabled="!isEditable"
                       :options="options">
        </b-form-select>
      </b-form-group>
      <b-form-group label="Comments visible for Reviewers, Management, Safety & Radiology inspectors:"
                    label-for="comments">
        <b-form-textarea id="comments"
                         v-model="evaluation.comments"
                         :readonly="!isEditable"
                         rows="3">
        </b-form-textarea>
      </b-form-group>
      <b-form-group label="Comments FOR USER (also visible to Reviewers and Management):"
                    label-for="comments for user">
        <b-form-textarea id="comments for user"
                         v-model="evaluation.comments_for_user"
                         :readonly="!isEditable"
                         rows="3">
        </b-form-textarea>
      </b-form-group>
    </p>
  </form>

</template>

<script>
  import options from '@/json/feasibility';

  export default {
    name: 'RapidAccessTechnicalEvaluationForm',
    props: {
      value: {
        type: Object,
        required: true,
      },
      isEditable: {
        type: Boolean,
        required: true,
      },
    },
    data() {
      return {
        evaluation: {},
        options: options.optionsRapidAccess,
      };
    },
    watch: {
      value: {
        handler() {
          this.evaluation = this.value;
        },
        immediate: true,
      },
      evaluation() {
        this.$emit('input', this.evaluation);
      },
    },
  };
</script>

<style scoped>
  p {
    font-weight: bold;
    margin-bottom: 0.5rem;
    margin-top: 1rem;
  }
</style>
